import React, { useState } from 'react';
import { X, FileText } from 'lucide-react';
import { Button } from '../ui/Button';

interface RiskProspect {
  id: string;
  first_name: string;
  last_name: string;
  notes?: string[];
  // Other properties not needed for this component
  [key: string]: any;
}

interface AddNoteModalProps {
  isOpen: boolean;
  onClose: () => void;
  prospect: RiskProspect;
  onAddNote: (note: string) => void;
}

const AddNoteModal: React.FC<AddNoteModalProps> = ({ 
  isOpen, 
  onClose, 
  prospect, 
  onAddNote 
}) => {
  const [note, setNote] = useState('');
  
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (note.trim()) {
      onAddNote(note.trim());
      setNote('');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold">Add Note</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        
        <div className="mb-4">
          <p className="text-gray-600">
            Adding note for <span className="font-medium text-gray-900">{prospect.first_name} {prospect.last_name}</span>
          </p>
        </div>
        
        {prospect.notes && prospect.notes.length > 0 && (
          <div className="mb-4">
            <h4 className="text-sm font-medium text-gray-700 mb-2">Previous Notes</h4>
            <div className="max-h-40 overflow-y-auto bg-gray-50 rounded-lg p-3">
              {prospect.notes.map((existingNote, index) => (
                <div key={index} className="mb-2 pb-2 border-b border-gray-200 last:border-0 last:mb-0 last:pb-0">
                  <p className="text-sm text-gray-600">{existingNote}</p>
                </div>
              ))}
            </div>
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="note" className="block text-sm font-medium text-gray-700 mb-1">
              New Note
            </label>
            <textarea
              id="note"
              rows={4}
              value={note}
              onChange={(e) => setNote(e.target.value)}
              className="w-full border rounded-lg p-2 focus:ring-2 focus:ring-primary focus:border-transparent"
              placeholder="Enter your note here..."
              required
            />
          </div>
          
          <div className="flex justify-end space-x-3">
            <Button
              variant="outline"
              onClick={onClose}
              type="button"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={!note.trim()}
            >
              Add Note
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddNoteModal;